module.exports = __webpack_public_path__ + "static/media/logo.e6ea0fe0.svg";